"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProblemBanner = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var styles = _interopRequireWildcard(require("./ProblemBanner.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ProblemBanner = _ref => {
  let {
    title,
    description
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "ProblemBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['logo-block']
  }, /*#__PURE__*/React.createElement(_icons.IconProductWarning24, {
    color: "icon-negative-default"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['info-block']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, {
    as: "h4"
  }, title), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, description)));
};
exports.ProblemBanner = ProblemBanner;